import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Collapse from '@mui/material/Collapse';
import classNames from 'classnames';
import css from './GroupContainer.css';

const GroupContainer = ({
    title = '',
    open = false,
    children = null,
    controlled = false,
    onTitleClick = () => {},
    name = '',
    defaultOpen = false,
    className = '',
    titleClassName = '',
}) => {
    const [stateOpen, setStateOpen] = useState(defaultOpen);

    const handleTitleClick = () => {
        if (!controlled) {
            setStateOpen(!stateOpen);
            return;
        }
        onTitleClick(name);
    };

    const useOpen = controlled ? open : stateOpen;

    return (
        <div className={classNames(css.container, className, { [css.open]: useOpen })}>
            <div className={classNames(css.titleContainer, titleClassName)} onClick={handleTitleClick}>
                <div className={css.arrow} />
                <div>
                    <Translate id={title} />
                </div>
            </div>

            <Collapse in={useOpen} timeout="auto" unmountOnExit>
                <div className={css.content}>{children}</div>
            </Collapse>
        </div>
    );
};

GroupContainer.propTypes = {
    open: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    controlled: PropTypes.bool,
    onTitleClick: PropTypes.func,
    name: PropTypes.string,
    className: PropTypes.string,
    titleClassName: PropTypes.string,
};

export default GroupContainer;
